import { roundPhpDecimal } from '../compile/php-decimal-values';
import { wallRunSizeIdForLength } from './wall-run-size';

export interface WallRunPiece {
  axis: 'x' | 'y'; at: number; floorFt?: number;
  span: { min: number; max: number }; z: { min: number; max: number }; sceneWallId?: string;
}

const round4 = (value: number): number => roundPhpDecimal(value, 4) || 0;

/** Canonical feet-key number: four decimals, no trailing zeroes or negative zero. */
export function wallRunKeyNumber(value: number): string {
  return String(round4(value));
}

/** Births and carved pieces keep the same continuous floor and saved scene-wall identity. */
export function wallRunPieceDescriptor(run: WallRunPiece, min = run.span.min, max = run.span.max): WallRunPiece & { key: string; floorFt: number } {
  const floorFt = run.floorFt ?? run.z.min;
  return {
    key: [wallRunKeyNumber(floorFt), run.axis, wallRunKeyNumber(run.at), wallRunKeyNumber(min), wallRunKeyNumber(max)].join(':'),
    floorFt: round4(floorFt), axis: run.axis, at: round4(run.at),
    span: { min: round4(min), max: round4(max) },
    z: { min: round4(run.z.min), max: round4(run.z.max) },
    ...(typeof run.sceneWallId === 'string' ? { sceneWallId: run.sceneWallId } : {}),
  };
}

/** The descriptor-only part of the world birth plan; material selection belongs to the caller. */
export function sceneWallPiecePlan(wall: WallRunPiece & { id: string }, itemId: string, stoneItemId: string) {
  const wallRun = wallRunPieceDescriptor(wall);
  wallRun.sceneWallId = wall.id;
  return { kind: 'wall-piece' as const, sceneWallId: wall.id,
    placementId: `scene-wall-${wall.id}:${wallRun.key}:${wallRunKeyNumber(wall.z.min)}:${wallRunKeyNumber(wall.z.max)}`
      + (itemId === stoneItemId ? '' : `:${itemId.slice(0, 8)}`),
    wallRun, inventorySize: wallRunSizeIdForLength(wallRun.span.max - wallRun.span.min) };
}
